/**
 * Created by pomoho on 15/9/15.
 */
export default {
	mainText:{
		en_us:[
			{
				pageTitle: 'Get $4.99 Premium membership for FREE',
				welcomeTitle:'Welcome!',
				welcomeSub:'Your friends invite you to enjoy the typing fun of TouchPal keyboard. Download now and both of you will receive one month of TouchPal Premium service for free.',
				buttonText:'Download & Receive',
				touchpalTitle:'What is TouchPal?',
				touchpalSub:'TouchPal Emoji Keyboard. It’s a free emoji keyboard app for Android users to type fast and easy with the best word prediction, over 800 emoji and emoticons, smartest auto-correction and swipe. TouchPal Emoji Keyboard is trusted by over 300 million users all over the world.'
			}
		],
		zh_cn:[
			{
				pageTitle: '立即领取$4.99会员资格',
				welcomeTitle:'欢迎！',
				welcomeSub:'您的好友邀请您一起感受触宝输入法的神奇。 立即下载触宝输入法, 您和您的好友即可免费领取各一个月触宝尊享会员资格。',
				buttonText:'下载并领取',
				touchpalTitle:'触宝是什么?',
				touchpalSub:'触宝输入法是最有趣最快速的手机输入法。 800+ Emoji表情, 智能纠错, 滑行输入, 超强预测能让您变成朋友眼中更有趣的人哦。'
			}
		],
		zh_tw:[
			{
				pageTitle: '立即領取$4.99會員資格',
				welcomeTitle:'歡迎！',
				welcomeSub:'您的好友邀請您一起感受觸寶輸入法的神奇。 立即下載觸寶輸入法, 您和您的好友即可免費領取各一個月觸寶尊享會員資格。',
				buttonText:'下載並領取',
				touchpalTitle:'觸寶是什麽?',
				touchpalSub:'觸寶輸入法是最有趣最快速的手機輸入法。 800+ Emoji表情, 智能糾錯, 滑行輸入, 超強預測能讓您變成朋友眼中更有趣的人哦。'
			}
		],
		zh_hk:[
			{
				pageTitle: '立即領取$4.99會員資格',
				welcomeTitle:'歡迎！',
				welcomeSub:'您的好友邀請您一起感受觸寶輸入法的神奇。 立即下載觸寶輸入法, 您和您的好友即可免費領取各一個月觸寶尊享會員資格。',
				buttonText:'下載並領取',
				touchpalTitle:'觸寶是什麼?',
				touchpalSub:'觸寶輸入法是最有趣最快速的手機輸入法。 800+ Emoji表情, 智能糾錯, 滑行輸入, 超強預測能讓您變成朋友眼中更有趣的人哦。'
			}
		]
	},
	coverText:{
		en_us:[{
			click: 'Click',
			open: 'open with browser'
		}],
		zh_cn:[{
			click: '点击',
			open: '在浏览器打开'
		}],
		zh_tw:[{
			click: '點擊',
			open: '在瀏覽器打開'
		}],
		zh_hk:[{
			click: '點擊',
			open: '在瀏覽器打開'
		}]
	}


};


/** WEBPACK FOOTER **
 ** ./src/scripts/basic/data.js
 **/